import { render, staticRenderFns } from "./TheDisasterRecoveryForm.vue?vue&type=template&id=915f60c0&scoped=true&"
import script from "./TheDisasterRecoveryForm.vue?vue&type=script&lang=js&"
export * from "./TheDisasterRecoveryForm.vue?vue&type=script&lang=js&"
import style0 from "./TheDisasterRecoveryForm.vue?vue&type=style&index=0&id=915f60c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915f60c0",
  null
  
)

export default component.exports